export default {
  namespaced: true,
  state: {
    idPedido: null,
    cartaoCredito: false,
    cartaoDebito: false,
    picPay: false,
    qrCodePicPay: null,
    urlPicPay: null
  },
  getters: {},
  mutations: {
    removerConfiguracoes (state) {
      state.idPedido = null
      state.cartaoCredito = false
      state.cartaoDebito = false
      state.picPay = false
      state.qrCodePicPay = null
      state.urlPicPay = null
    },
    removePreenchimentos (state) {
      state.preencherTelefone = false
      state.preencherCidade = false
      state.preencherCpf = false
      state.loginExterno = false
    },
    removeOpcoesPagamento (state) {
      state.cartaoCredito = false
      state.cartaoDebito = false
      state.picPay = false
    },
    idPedidoAtual (state, payload) {
      state.idPedido = payload
    },
    cartaoCredito (state, payload) {
      state.cartaoCredito = payload
    },
    cartaoDebito (state, payload) {
      state.cartaoDebito = payload
    },
    picPay (state, payload) {
      state.picPay = payload
    },
    qrCodePicPay (state, payload) {
      state.qrCodePicPay = payload
    },
    urlPicPay (state, payload) {
      state.urlPicPay = payload
    }
  },
  actions: {
    removerConfiguracoes ({commit}, payload) {
      commit('removerConfiguracoes', payload)
    },
    removeOpcoesPagamento ({ commit }, payload) {
      commit('removeOpcoesPagamento', payload)
    },
    removePreenchimentos ({ commit }, payload) {
      commit('removePreenchimentos', payload)
    },
    idPedidoAtual ({ commit }, payload) {
      commit('idPedidoAtual', payload)
    },
    cartaoCredito ({ commit }, payload) {
      commit('cartaoCredito', payload)
    },
    cartaoDebito ({ commit }, payload) {
      commit('cartaoDebito', payload)
    },
    picPay ({ commit }, payload) {
      commit('picPay', payload)
    },
    qrCodePicPay ({ commit }, payload) {
      commit('qrCodePicPay', payload)
    },
    urlPicPay ({ commit }, payload) {
      commit('urlPicPay', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/finalizar-compra.js